import { render, staticRenderFns } from "./RoomDynamicCard.vue?vue&type=template&id=61b3838c&"
import script from "./RoomDynamicCard.vue?vue&type=script&lang=ts&"
export * from "./RoomDynamicCard.vue?vue&type=script&lang=ts&"
import style0 from "./RoomDynamicCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports